import React,{useState} from 'react';

export default function useFechaSeleccionada() {
   const[fecha, setFecha] = useState({});

   return{
      fecha,
      setFecha
   }
}